var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListaDeQuehaceres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.8,
    height: 37.785,
    viewBox: "0 0 33.8 37.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e51b26;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.52,0H4.28A4.285,4.285,0,0,0,0,4.28V31.586A2.216,2.216,0,0,0,2.214,33.8h9.692a.738.738,0,1,0,0-1.476H2.214a.739.739,0,0,1-.738-.738V4.28a2.808,2.808,0,0,1,2.8-2.8H26.29a4.262,4.262,0,0,0-1.051,2.8V28.063a1.235,1.235,0,0,1-2.406.391l-1.112-3.337a2.3,2.3,0,0,0-4.489.728v.575H13.407a.738.738,0,0,0,0,1.476h3.825v3.672a8.166,8.166,0,0,0,.632,3.158l1.086,2.606a.738.738,0,1,0,1.362-.568l-1.086-2.606a6.7,6.7,0,0,1-.518-2.59V25.845a.827.827,0,0,1,1.612-.262l1.112,3.337a2.711,2.711,0,0,0,5.282-.857V15.411l.986.984a9.233,9.233,0,0,1,2.729,6.579v7.845A13.887,13.887,0,0,1,29.1,36.731a.738.738,0,0,0,1.334.632,15.373,15.373,0,0,0,1.473-6.545V22.973a10.7,10.7,0,0,0-3.162-7.623l-2.029-2.025V12.62h4.871A2.216,2.216,0,0,0,33.8,10.406V4.28A4.285,4.285,0,0,0,29.52,0Zm2.8,10.406a.739.739,0,0,1-.738.738H26.715V4.28a2.8,2.8,0,0,1,5.609,0Zm0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M195.738,438a.738.738,0,1,0,.522.216A.743.743,0,0,0,195.738,438Zm0,0",
    transform: "translate(-180.609 -405.672)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M59.867,55.476A1.478,1.478,0,0,0,58.391,54H55.144a1.478,1.478,0,0,0-1.476,1.476v3.247A1.478,1.478,0,0,0,55.144,60.2h3.247a1.478,1.478,0,0,0,1.476-1.476Zm-1.476,3.247H55.144V55.476h3.247v3.247Zm0,0",
    transform: "translate(-49.707 -50.015)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M59.867,175.476A1.478,1.478,0,0,0,58.391,174H55.144a1.478,1.478,0,0,0-1.476,1.476v3.247a1.478,1.478,0,0,0,1.476,1.476h3.247a1.478,1.478,0,0,0,1.476-1.476Zm-1.476,3.247H55.144v-3.247h3.247v3.247Zm0,0",
    transform: "translate(-49.707 -161.159)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M58.391,294H55.144a1.477,1.477,0,0,0-1.476,1.476v3.247a1.477,1.477,0,0,0,1.476,1.476h3.247a1.478,1.478,0,0,0,1.476-1.476v-3.247A1.478,1.478,0,0,0,58.391,294Zm0,4.723H55.144v-3.247h3.247v3.247Zm0,0",
    transform: "translate(-49.707 -272.303)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M223.22,119.476a.738.738,0,1,0,0-1.476h-5.088a.738.738,0,1,0,0,1.476Zm0,0",
    transform: "translate(-201.351 -109.292)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M172.406,119.476a.738.738,0,1,0-.522-.216A.743.743,0,0,0,172.406,119.476Zm0,0",
    transform: "translate(-158.999 -109.292)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M172.4,239.476h8.462a.738.738,0,1,0,0-1.476H172.4a.738.738,0,0,0,0,1.476Zm0,0",
    transform: "translate(-158.995 -220.436)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListaDeQuehaceres);
export default __webpack_public_path__ + "static/media/lista-de-quehaceres.eddc4151c04e303db3d3e6bc9525b7cc.svg";
export { ForwardRef as ReactComponent };